export function formatDescription(text: string): string {
  return text.toLowerCase();
}
